import { getEnvVariable } from 'utils/env';

export const API_ENDPOINT = getEnvVariable('adminApiBaseUrl', process.env.API_URL);
export const ACCOUNTS_API_ENDPOINT = getEnvVariable(
  'accountsApiBaseUrl',
  process.env.ACCOUNTS_API_BASE_URL,
);

export const DOCUMENTS_API_ENDPOINT = getEnvVariable(
  'documentsApiBaseUrl',
  process.env.DOCUMENTS_API_BASE_URL,
);

export const PRICING_API_ENDPOINT = getEnvVariable(
  'pricingApiBaseUrl',
  process.env.PRICING_API_BASE_URL,
);

export const NOTIFICATIONS_API_ENDPOINT = getEnvVariable(
  'notificationsApiUrl',
  process.env.NOTIFICATIONS_API_URL,
);

export const TELEPHONY_API_ENDPOINT = getEnvVariable(
  'telephonyApiUrl',
  process.env.TELEPHONY_API_URL,
);
export const FORMS_API_URL = getEnvVariable('formsApiUrl', process.env.FORMS_API_URL);

export const FEES_API_URL = getEnvVariable('feesApiUrl', process.env.FEES_API_URL);

export const UNDERWRITING_API_URL = getEnvVariable(
  'underwritingApiUrl',
  process.env.UNDERWRITING_API_BASE_URL,
);

export const LOANS_API_ENDPOINT = getEnvVariable('loansApiUrl', process.env.LOANS_API_URL);

export const LOAN_PROCESSING_API_ENDPOINT = getEnvVariable(
  'loanProcessingApiUrl',
  process.env.LOAN_PROCESSING_API_URL,
);

export const AUS_API_ENDPOINT = getEnvVariable('ausApiUrl', process.env.AUS_API_URL);

export const AI_API_ENDPOINT = getEnvVariable('aiApiUrl', process.env.AI_API_URL);

export const API_GET_SSO_TOKEN = 'Sso/token';

export const REQUEST_SOURCE_MODE = {
  BROWSER: 'Browser',
  IFRAME: 'Iframe',
  TPO_CERT: 'TpoCert',
};

export const SIGNAL_R_LOAN_APPLICATION_CONNECTION_URL = `${API_ENDPOINT}loanEditorHub`;

export const SIGNAL_R_TELEPHONY_CONNECTION_URL = `${TELEPHONY_API_ENDPOINT}/messagehub`;

export const SIGNAL_R_PUSH_NOTIFICATIONS_CONNECTION_URL = `${NOTIFICATIONS_API_ENDPOINT}notificationCenterHub`;

export const SIGNAL_R_TEAM_CHAT_CONNECTION_URL = `${NOTIFICATIONS_API_ENDPOINT}chats/realtime`;

export const SIGNAL_R_AI_CHAT_NEGOTIATE_URL = `${AI_API_ENDPOINT}aiChatHub/negotiate`;

export const SIGNAL_R_AI_PROCESS_RUNS_CONNECTION_URL = `${AI_API_ENDPOINT}hubs/process`;

export const REQUEST_RESULT_STRUCTURE = {
  FLAT_VALUES: 'FlatValues',
  HIERARCHY: 'Hierarchy',
};

export const APPLY_API_ENDPOINT = getEnvVariable('applyApiUrl', process.env.APPLY_API_URL);

export const CRM_API_ENDPOINT = getEnvVariable('crmApiUrl', process.env.CRM_API_URL);

export const INTEGRATIONS_API_ENDPOINT = getEnvVariable(
  'integrationsApiUrl',
  process.env.INTEGRATIONS_API_URL,
);

export const APPLY_FORM_URL = getEnvVariable('applyFormUrl', process.env.APPLY_FORM_URL);

export const TPO_SIGNUP_URL = getEnvVariable('tpoSignupUrl', process.env.TPO_SIGNUP_URL);
